module.exports = __webpack_public_path__ + "img/sidebarClose.9628a944.svg";